// SPZ-1550: remove
export const resistancesMockData = ['Disease/Pests', 'Heat', 'Cold', 'Cracking', 'Bolting', 'Other'];
